import { z } from 'zod';

export const HistoricalClaimFormSchema = z
  .object({
    id: z.string(),
    customerFirstName: z.string(),
    customerLastName: z.string(),
    customerEmail: z.string(),
    customerPhone: z.string(),
    address: z.object({
      placeId: z.string(),
      address: z.string(),
    }),
    dateOfClaim: z.number().nullable(),
    fabricatorName: z.string(),
    fabricatorJobReference: z.string(),
    fmiWorksOrderNumber: z.string(),
    originalInstallDate: z.number().nullable(),
    glazed: z.object({
      id: z.string(),
      name: z.string(),
    }),
    inspectedBy: z.string(),
    glassFaultDetected: z.array(z.string()),
    otherFaultDescription: z.string(),
    unitsAffected: z.number().nullable(),
    unitsFailed: z.number().nullable(),
    glazierName: z.string(),
    d365OrderNumber: z.string(),
    originalFmiCosts: z.number().nullable(),
    d365ReplacementCosts: z.number().nullable(),
    attachments: z.array(z.unknown()),
    internalNotes: z.string(),
  })
  .superRefine((data, ctx: any) => {
    if (data.customerEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.customerEmail)) {
      ctx.addIssue({
        path: ['customerEmail'],
        message: 'Please enter a valid email',
        code: 'custom',
      });
    }

    if (
      data.unitsAffected != null &&
      data.unitsFailed != null &&
      data.unitsFailed > data.unitsAffected
    ) {
      ctx.addIssue({
        path: ['unitsFailed'],
        message: 'Failed units cannot be greater than affected units',
        code: 'custom',
      });
    }
  });
